import { FC } from "react";

import SelectSalesChannelContainer from "@app/containers/selectSalesChannel";

const SelectSalesChannelPage: FC = () => <SelectSalesChannelContainer />;

export default SelectSalesChannelPage;
